/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import routers from './routers'
import numberFormats from 'theme/i18n/numberFormats'
import currencyJs from 'currency.js'
import { randomInRange } from '@/helpers'

export function price (value, store) {
  if (isNaN(value)) {
    return value
  }
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  let formatValue = value
  let currency = store.state.storeConfig.config.base_currency_code
  return currencyJs(formatValue, numberFormats[currency]).format()
}

export function convertToMeasure (valueToConvert, measureUnit, toFixed = 2) {
  if (valueToConvert) {
    if (measureUnit === 'cm') {
      return valueToConvert
    } else if (measureUnit === 'inch') {
      return parseFloat(valueToConvert * 0.393701).toFixed(toFixed).toString().replace('.', ',')
    }
  } else {
    return valueToConvert
  }
}

export function localizeUrl (value) {
  let $store = global.$store
  const storeViewCodeRegex = /(({)+(storeViewCode)(})+)|(store_view_code)|(_)/g
  return value.replace(storeViewCodeRegex, $store.state.ui.codeLang)
}

export function generateKeyByRandomInRange (value) {
  if (isNaN(value)) {
    value = 0
  }
  return `${randomInRange(value, value + 1000)}`
}

export default {
  price,
  convertToMeasure,
  localizeUrl,
  generateKeyByRandomInRange,
  ...routers
}
